import type { JSX } from "react";
import { TrendDelta } from "./TrendDelta";
import { Term } from "../Term";

export function StatCard({ label, value, delta, tone }: {
  label: string; value: string; delta?: number; tone?: "ok" | "warn" | "err";
}): JSX.Element {
  const cls = tone ? ` cc-stat-${tone}` : "";
  return (
    <div className={`cc-stat${cls}`}>
      <div className="cc-stat-label"><Term>{label}</Term></div>
      <div className="cc-stat-value">{value}</div>
      {delta !== undefined && <TrendDelta pct={delta} />}
    </div>
  );
}
